import {
  addDoc,
  collection,
  onSnapshot,
  orderBy,
  query,
  serverTimestamp,
  updateDoc,
  doc,
} from "firebase/firestore";
import { db } from "./firebase";

const INQUIRIES_COLLECTION = "inquiries";

function mapInquiry(snapshot) {
  const data = snapshot.data() || {};
  return {
    id: snapshot.id,
    source: data.source || "custom_bulk",
    status: data.status || "pending",
    company: data.company || "",
    contact_name: data.contact_name || "",
    email: data.email || "",
    phone: data.phone || "",
    quantity: Number(data.quantity) || 0,
    use_case: data.use_case || "",
    budget: data.budget || "",
    message: data.message || "",
    whatsapp: data.whatsapp || "",
    instagram: data.instagram || "",
    facebook: data.facebook || "",
    created_at: data.created_at?.toDate ? data.created_at.toDate() : null,
  };
}

export async function createInquiry(payload) {
  const source = payload?.source || "custom_bulk";
  const base = {
    source,
    status: "pending",
    message: payload?.message || "",
    email: payload?.email || "",
    created_at: serverTimestamp(),
    updated_at: serverTimestamp(),
  };

  if (source === "contact") {
    await addDoc(collection(db, INQUIRIES_COLLECTION), {
      ...base,
      whatsapp: payload?.whatsapp || "",
      instagram: payload?.instagram || "",
      facebook: payload?.facebook || "",
    });
    return;
  }

  await addDoc(collection(db, INQUIRIES_COLLECTION), {
    ...base,
    company: payload?.company || "",
    contact_name: payload?.contact_name || "",
    phone: payload?.phone || "",
    quantity: Number(payload?.quantity) || 0,
    use_case: payload?.use_case || "",
    budget: payload?.budget || "",
  });
}

export function subscribeInquiries(callback, onError) {
  const q = query(collection(db, INQUIRIES_COLLECTION), orderBy("created_at", "desc"));
  return onSnapshot(
    q,
    (snapshot) => callback(snapshot.docs.map(mapInquiry)),
    (error) => {
      if (typeof onError === "function") onError(error);
    }
  );
}

export async function updateInquiryStatus(id, status) {
  await updateDoc(doc(db, INQUIRIES_COLLECTION, id), {
    status,
    updated_at: serverTimestamp(),
  });
}
